import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { VietnamTicketingTermsPage } from "./legal.ticketing-vietnam";

export const Route = createFileRoute("/vi/legal/ticketing-vietnam")({
  head: () => ({
    meta: [{ title: "Điều khoản vé sự kiện (Việt Nam) — Banana Cards" }],
    links: alternateLinkList("/legal/ticketing-vietnam", "vi"),
  }),
  component: VietnamTicketingTermsPage,
});